module.exports = __webpack_public_path__ + "media/images/icon-www-3b0ecf38.png";